import { draftDiscount } from "@redotech/redo-model/discount/discount-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateDiscount = {
  name: "updateDiscount" as const,
  input: z.object({ _id: zExt.objectId(), configuration: draftDiscount }),
  output: z.null(),
};
